import { observer } from 'mobx-react-lite';
import { scheduleCancelButton, scheduleDialogHeader } from './ScheduleDatePicker.locstring.json';
import setScheduleTime from '../mutators/setScheduleTime';
import { default as getStore } from '../store/store';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { addDays, addHours, isAfter, now, OwaDate, startOfDay } from 'owa-datetime';
import { DateTimePicker } from 'owa-datetimepicker';
import loc from 'owa-localize';
import { scheduleSaveButton } from 'owa-locstrings/lib/strings/schedulesavebutton.locstring.json';
import { lazyResetFocus } from 'owa-mail-focus-manager';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./ScheduleDatePicker.scss');

export interface ScheduleDatePickerProps {
    minTime: OwaDate;
    onScheduleItemClicked: (date: OwaDate) => void;
    onClose: () => void;
}

const ScheduleDatePicker = observer(function ScheduleDatePicker(props: ScheduleDatePickerProps) {
    const onChanged = (date: OwaDate) => {
        setScheduleTime(date);
    };
    const onScheduleDatePickerSave = () => {
        const { onScheduleItemClicked, onClose } = props;
        onScheduleItemClicked(getStore().scheduleTime);
        onClose();
        lazyResetFocus.importAndExecute();
    };
    const onScheduleDatePickerCancel = () => {
        props.onClose();
        lazyResetFocus.importAndExecute();
    };
    const getDefaultDate = () => {
        const currentTime = now();
        const today8AM = addHours(startOfDay(currentTime), 8);
        // if minTime is after today8AM, use tomorrow 8AM.
        return isAfter(props.minTime, today8AM) ? addDays(today8AM, 1) : today8AM;
    };
    const minTime = props.minTime;
    setScheduleTime(getDefaultDate());
    return (
        <Dialog
            key="ScheduleDatePicker"
            hidden={false}
            onDismiss={onScheduleDatePickerCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: loc(scheduleDialogHeader),
            }}
            styles={{
                main: styles.fixWidthContextMenu,
            }}>
            <DateTimePicker
                minDate={minTime}
                value={getDefaultDate()}
                onChanged={onChanged}
                showDuration={false}
            />
            <DialogFooter styles={{ actionsRight: styles.footerRight }}>
                <PrimaryButton onClick={onScheduleDatePickerSave} text={loc(scheduleSaveButton)} />
                <DefaultButton
                    onClick={onScheduleDatePickerCancel}
                    text={loc(scheduleCancelButton)}
                />
            </DialogFooter>
        </Dialog>
    );
});

export default function showScheduleDatePickerDialog(
    minTime: OwaDate,
    onScheduleItemClicked: (date: OwaDate) => void
) {
    const dialogDiv = document.createElement('div');
    dialogDiv.id = 'snoozeDatePickerDialog';
    document.body.appendChild(dialogDiv);

    function cleanup() {
        ReactDOM.unmountComponentAtNode(dialogDiv);
        document.body.removeChild(dialogDiv);
    }

    ReactDOM.render(
        <ScheduleDatePicker
            minTime={minTime}
            onScheduleItemClicked={onScheduleItemClicked}
            onClose={cleanup}
        />,
        dialogDiv
    );
}
